var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7245 13.0876L14.0245 18.7876H11.7245V16.4876L17.4245 10.7876L19.7245 13.0876ZM23.1245 12.2876C23.1245 12.5876 22.8245 12.8876 22.5245 13.1876L20.0245 15.6876L19.1245 14.7876L21.7245 12.1876L21.1245 11.5876L20.4245 12.2876L18.1245 9.98762L20.3245 7.88762C20.5245 7.68762 20.9245 7.68762 21.2245 7.88762L22.6245 9.28762C22.8245 9.48762 22.8245 9.88762 22.6245 10.1876C22.4245 10.3876 22.2245 10.5876 22.2245 10.7876C22.2245 10.9876 22.4245 11.1876 22.6245 11.3876C22.9245 11.6876 23.2245 11.9876 23.1245 12.2876ZM3.02448 20.1876V4.18762H10.0245V9.18762H15.0245V10.6876L17.0245 8.68762V8.18762L11.0245 2.18762H3.02448C1.92448 2.18762 1.02448 3.08762 1.02448 4.18762V20.1876C1.02448 21.2876 1.92448 22.1876 3.02448 22.1876H15.0245C16.1245 22.1876 17.0245 21.2876 17.0245 20.1876H3.02448ZM11.0245 17.2876C10.8245 17.2876 10.6245 17.3876 10.5245 17.3876L10.0245 15.1876H8.52448L6.42448 16.8876L7.02448 14.1876H5.52448L4.52448 19.1876H6.02448L8.92447 16.5876L9.52448 18.8876H10.5245L11.0245 18.7876V17.2876Z",
    fill: "#E0565F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeIcon2);
export default __webpack_public_path__ + "static/media/welcome-icon-2.4aefa281.svg";
export { ForwardRef as ReactComponent };